module.exports = __webpack_public_path__ + "img/img12.b60143b2.svg";